import { Routes } from './routes'
import { GlobalStyle } from './assets/globalStyle/GlobalStyle'
import '@fortawesome/fontawesome-free/css/all.min.css'

function App() {
  return (
    <>
      <GlobalStyle />
      <Routes />
    </>
  )
}

export default App
